import React from "react";

// form & validsation
import * as yup from "yup";
import { FormLabel, FormInput, FormError, FormRadio } from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";

// schema
const Step03schema = yup
  .object()
  .shape({
    user_details: yup
      .object()
      .shape({
        partner_first_name: yup.string().required("You must provide a value"),
        partner_last_name: yup.string().required("You must provide a value"),
        partner_age: yup
          .number("please enter a whole number")
          .required("You must provide a value")
          .positive()
          .integer(),
      })
      .required(),
  })
  .required();

export function Step03({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(Step03schema),
  });

  const handleData = (values) => {
    const copy_data = Object.assign({}, store.user_details);
    const merger_current_values = { ...copy_data, ...values.user_details };
    const mergeToStore = { ...store, user_details: merger_current_values };
    onSubmit(mergeToStore);
  };

  return (
    <form id="divorce-form" onSubmit={handleSubmit(handleData)}>
      <section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="get_married"
            className={customClasses.questionText}
            error={errors?.user_details?.partner_first_name?.message}
          >
            Your ex-partner's first name?
          </FormLabel>
          <article>
            <FormInput
              placeholder="Partner First Name"
              id="user_details.partner_first_name"
              type="text"
              name="user_details.partner_first_name"
              error={errors?.user_details?.partner_first_name?.message}
              register={register}
            />
          </article>
        </section>

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="user_details.partner_last_name"
            className={customClasses.questionText}
            error={errors?.user_details?.partner_last_name?.message}
          >
            Your ex-partner's last name?
          </FormLabel>
          <article>
            <FormInput
              placeholder="Partner Last Name"
              id="user_details.partner_last_name"
              type="text"
              name="user_details.partner_last_name"
              error={errors?.user_details?.partner_last_name?.message}
              register={register}
            />
          </article>
        </section>

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="user_details.partner_age"
            className={customClasses.questionText}
            error={errors?.user_details?.partner_age?.message}
          >
            Your ex-partner's age?
          </FormLabel>
          <article>
            <FormInput
              placeholder="Partner Age"
              id="user_details.partner_age"
              type="text"
              name="user_details.partner_age"
              error={errors?.user_details?.partner_age?.message}
              register={register}
            />
            {errors?.user_details?.partner_age?.message && (
              <p className={customClasses.errorText}>Enter a whole number </p>
            )}
          </article>
        </section>
      </section>
    </form>
  );
}
